/* global G */
import { pipe } from '@gaia/util'
import { hasNamespace } from '@gaia/trait/has'
import { usesNamespace } from '@gaia/trait/uses'
import { withDescriptor, withObjectFreeze } from '@gaia/trait/with'
import api from '@platform/adapter/clipboard/api'

const descriptor = 'adapterClipboard'

/**
 * Clipboard Adapter.
 *
 * Exposes methos to interact with the platform-specific clipboard.
 *
 * @memberOf Gaia.Adapter#
 * @typedef Adapter.Clipboard
 *
 * @param {Gaia.Web.Application|Gaia.Mobile.Application} obj    the platform Application
 * @returns {function(*=): *}
 */
const adapterFn = obj => pipe(
  withDescriptor(descriptor),
  hasNamespace(G.API),
  usesNamespace(G.API, api(obj)),
  withObjectFreeze,
)({})

export default adapterFn
